export const UNKNOWN_INPUT_TYPE = 'from_url';
export const COMMA_SEPARATOR = ', ';
export const SEMI_SEPARATOR = ': ';
